import { stats } from "@/mocks/site";

export default function StatsStrip() {
  return (
    <section className="border-b border-background-200 bg-background-50" aria-label="瓜网数据">
      <div className="mx-auto grid w-full max-w-[1400px] grid-cols-2 gap-6 px-4 py-8 md:px-6 lg:grid-cols-4">
        {stats.map((item) => (
          <div key={item.label} className="border-l-2 border-primary-300 pl-4">
            <p className="font-heading text-2xl font-bold text-primary-700 md:text-3xl">{item.value}</p>
            <p className="mt-1 text-sm text-foreground-600">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}